import type { GroupBookingData, Occupancy } from '@/scopes/account/group-responsible/domain/types'
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types'
import { getParticipantName } from './utils'

function mapOccupancy(assigned: number, max: number): Occupancy {
  return {
    occupied: assigned,
    max,
  }
}

export function mapRooms(childBookings: GroupBookingAPIResponse['data']['childBookings']): GroupBookingData['rooms'] {
  return childBookings
    .map((room) => {
      const accommodationService = room.services.find(service => service.typeOfService === 'Accommodation')

      const occupancy = mapOccupancy(room.assignedParticipants, room.maxParticipants)
      const occupancyText = `${occupancy.occupied}/${occupancy.max}`

      return {
        id: room.bookingNumber.toString(),
        name: room.bookingNumber.toString(),
        type: room.roomType,
        occupancy,
        occupancyText,
        participants: room.participants.map(participant =>
          getParticipantName(participant.firstName, participant.lastName),
        ),
        accommodationName: accommodationService?.name || '',
        participantsId: room.participants.map(participant => participant.participantId),
      }
    })
    .reduce((acc, room) => {
      acc[room.id] = room
      return acc
    }, {} as GroupBookingData['rooms'])
}
